import { ArrowRight } from "lucide-react";
import { type Versions } from "../../context/ChatContext";

const Sources = ({ message, version }: {
    message?: { sources?: { link: string, nomeartigo: string }[] }, version?: Versions
}) => {
    return (
        <>
            {version &&
                version.isCompleted &&
                <div className="mt-2">
                    {message?.sources && message.sources.length > 0 && (
                        <div className="">
                            <p className="text-sm font-semibold text-gray-700 mb-1">Artigos relacionados:</p>
                            {message.sources.map((s, index) => (
                                <div key={index} className="text-xs mt-2 underline flex flex-row gap-1 items-center">
                                    <ArrowRight size={14} />
                                    <a href={s.link} target="_blank">{s.nomeartigo}</a>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            }
        </>
    )
};

export default Sources;